<template>
  <v-card flat>
    <v-card-title class="px-0 pt-0">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            @click="modal = true"
          >
            {{ mdiTable }}
          </v-icon>
        </template>
        <span>Open tension beats table</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            @click="chart = true"
          >
            {{ mdiChartBar }}
          </v-icon>
        </template>
        <span>Open tension beats chart</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text v-if="loading" class="text-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-card-text>
    <v-card-text class="pa-0" v-else>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th></th>
              <th class="text-left">
                Avg per Session
              </th>
              <th class="text-left">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="value in ui" :key="value.key">
              <td class="caption">{{ value.name }}</td>
              <td class="caption">{{ timeToString((info[value.key] * 1000) / (info.players || 1)) }}</td>
              <td class="caption">{{ timeToString(info[value.key] * 1000) }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <time-in-ui-by-tension-beats-modal
      v-if="modal"
      @close="modal = false"
    />
    <time-in-ui-chart-by-tension-beats
      v-if="chart"
      :ui="ui"
      @close="chart = false"
    />
  </v-card>
</template>

<script>
import helper from '../../../plugins/helpers/mixin-helper';
import { mdiTable, mdiChartBar } from '@mdi/js';
export default {
  mixins: [
    helper
  ],
  components: {
    timeInUiByTensionBeatsModal: () => import('./timeInUiByTensionBeatsModal.vue'),
    timeInUiChartByTensionBeats: () => import('./timeInUiChartByTensionBeats.vue')
  },
  data () {
    return {
      mdiTable,
      mdiChartBar,
      loading: true,
      modal: false,
      chart: false,
      ui: [
        {
          name: 'Map',
          key: 'map'
        },
        {
          name: 'Investigation space',
          key: 'is'
        },
        {
          name: 'Inventory',
          key: 'inventory'
        },
        {
          name: 'Craft',
          key: 'craft'
        },
        {
          name: 'Codex',
          key: 'codex'
        },
        {
          name: 'Perks',
          key: 'perks'
        },
        {
          name: 'Stash',
          key: 'stash'
        },
        {
          name: 'Item received',
          key: 'itemreceived'
        },
        {
          name: 'Tutorial',
          key: 'tutorial'
        }
      ],
      info: {
        map: 0,
        is: 0,
        inventory: 0,
        craft: 0,
        codex: 0,
        perks: 0,
        stash: 0,
        itemreceived: 0,
        tutorial: 0,
        players: 0
      }
    }
  },
  watch: {
    async '$route.params' () {
      await this.getData()
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/global-time-in-ui`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.info = data
      }
      this.loading = false
    }
  }
}
</script>